import { isArray, debounce } from 'underscore';
import getParsedFontSize from 'utility/ads/get-parsed-font-size';

// Breakpoints based on 16px font-size
function googleAdRefresher(adContainerBreakpoints) {
  if (!adContainerBreakpoints || !isArray(adContainerBreakpoints)) {
    throw new Error('adContainerBreakpoints must be an array of the CSS breakpoint widths for the ad container');
  }

  const fontSize = getParsedFontSize();
  const sortedAdContainerBreakpoints = adContainerBreakpoints.map(breakpoint => {
    return (breakpoint * fontSize / 16);
  }).sort((a, b) => {
    return b - a;
  });


  function getGoogleAdWidthContainer() {
    let i;

    // Find which CSS breakpoint we are currently in
    const pageWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    for (i = 0; i < sortedAdContainerBreakpoints.length; i++) {
      if (pageWidth > sortedAdContainerBreakpoints[i]) {
        return i;
      }
    }

    return sortedAdContainerBreakpoints.length;
  }

  let currentGoogleAdWidthContainer = getGoogleAdWidthContainer();

  // Refresh the Google Ad if the ad container has crossed a breakpoint. When
  // googletag hasn't loaded yet, bail without syncing so the missed change is
  // retried on the next invocation once googletag is available.
  function refreshIfBreakpointChanged() {
    if (!window.googletag) {
      return;
    }

    const newGoogleAdWidthContainer = getGoogleAdWidthContainer();
    if (currentGoogleAdWidthContainer !== newGoogleAdWidthContainer) {
      window.googletag.pubads().refresh();
      currentGoogleAdWidthContainer = newGoogleAdWidthContainer;
    }
  }

  window.addEventListener('resize', debounce(() => {
    if (document.visibilityState !== 'visible') {
      return;
    }

    refreshIfBreakpointChanged();
  }, 200));

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') {
      return;
    }

    refreshIfBreakpointChanged();
  });
}

export default googleAdRefresher;
